module.exports = {
  "Ackley": {
    description: "Kirk and Patricia Ackley, of Ephrata, Wash., bought a Clayton home in 2006 despite a last-minute change in promised loan terms. They asked to refinance at the promised rate, but their Clayton lender repossessed their home.",
    term: 24,
    interest: 12.5,
    price: 96005.56,
    other: 10074.92,
    down: 4.9,
    depreciates: true
  },
  "Mansfield": {
    description: "After losing her previous home to a tornado, Dorothy Mansfield, of Bladenboro, N.C., bought a home from Clayton in 2011. Within 18 months, her lender was trying to foreclose on her home and land.",
    term: 20,
    interest: 9.74,
    price: 56734,
    other: 3750.10,
    down: 0,
    depreciates: true
  },
  "Galler": {
    description: "Tiffany Galler was a single mother living in Crestview, Fla., in 2005, when she purchased a mobile home with a Clayton loan. After paying more than the sales price over eight years of payments, her home was repossessed.",
    term: 20,
    interest: 10.5,
    price: 37195,
    other: 5322.34,
    down: 9.4,
    depreciates: true
  },
  "trailer": {
    description: "Set your own values below to explore how interest rates, loan terms, down payments and costs shape a borrower’s loan experience.",
    term: 24,
    interest: 10,
    price: 80000,
    other: 4000,
    down: 10,
    customize: true,
    depreciates: true
  }
};